// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_0d624b9a27--tooltip--Rln6T","arrow":"_0d624b9a27--arrow--GMnRq"};